import React from 'react';
import moment from 'moment';

import CmsApi from '../../helpers/CmsApi';
import NotificationSubscriptions from './subscriptions/NotificationSubscriptions';

export default function MyProfile() {
	let lastVisit = '';
	if (CmsApi.currentUser?.lastLogin) {
		lastVisit = moment.duration(moment().diff(moment(CmsApi.currentUser?.lastLogin))).humanize();
	}
	return (
		<div>
			<p>
				Welcome {CmsApi.currentUser?.firstName || CmsApi.currentUser?.displayName || 'fellow human'}.{' '}
				{lastVisit &&
					`It has been 
				${lastVisit} since you last authenticated.`}
			</p>
			<h2>Notification Subscriptions</h2>
			<NotificationSubscriptions />
		</div>
	);
}
